import React, { useState, useEffect, useMemo } from 'react'
import { connect } from "react-redux";
import TopBarNav from '../common/TopBarNav'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid';
import withStyles from '@material-ui/core/styles/withStyles'
import { useHistory } from 'react-router-dom'
import DataTable from 'react-data-table-component';
import * as purchaseActions from '../../actions/purchase/PurchaseActions'
import * as navigationActions from '../../actions/common/NavigationActions'
import { downloadCSV, getFilteredTableTitle } from "../common/Utils";
import TableFilterComponent from '../common/TableFilterComponent'
import PurchaseStyles from './PurchaseStyles'
import { bindActionCreators } from 'redux'
import BreadcrumbsHistory from '../common/BreadcrumbsHistory'
import { Backdrop, CircularProgress } from '@material-ui/core';
import { useTranslation } from 'react-i18next'
import { customStylePrincipal, customStylePrincipalAP } from '../common/CommonStyles';
import TableContextMenuComponent from '../common/TableContextMenuComponent';
import Constants from '../common/Constants.json'

const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de', selectAllRowsItem: true, selectAllRowsItemText: 'Todos' };

const PurchaseListByStatus = ({ classes, ...props }) => {
    const history = useHistory()
    const [filterText, setFilterText] = useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [startDate, setStartDate] = useState()
    const [endDate, setEndDate] = useState()
    const [searchButton, setSearchButton] = useState(0)
    const { match: { params } } = props;
    const [open, setOpen] = useState(false);
    const { t } = useTranslation()
    const getExcelConfiguration = (status) => {
        switch (status) {
            case '27':
                return excelConfigurationPaymentPending
            case '28':
                return excelConfigurationPaidRejected
            default:
                return excelConfiguration
        }
    }
    const getTableColumns = (status) => {
        switch (status) {
            case '27':
                return ColumnsForStatusPaymentPending
            case '28':
                return ColumnsForStatusPaidRejected
            default:
                return ColumnsForStatusAssigned
        }
}
    const excelConfiguration = [
        {
            selector: 'folioQuote',
            label: 'Folio cotización'
        },
        {
            selector: 'orderDate',
            label: 'Fecha'
        },
        {
            selector: 'vin',
            label: 'Vin'
        },
        {
            selector: 'poNumber',
            label: 'Número OC'
        },
        {
            selector: 'brand',
            label: 'Marca'
        },
        {
            selector: 'model',
            label: 'Modelo'
        },
        {
            selector: 'version',
            label: 'Versión'
        },
        {
            selector: 'year',
            label: 'Año'
        },
        {
            selector: 'daysPassed',
            label: 'Días transcurridos'
        }
    ]
    const excelConfigurationPaymentPending = [
        {
            selector: 'folioQuote',
            label: 'Folio cotización'
        },
        {
            selector: 'poNumber',
            label: 'Número OC'
        },
        {
            selector: 'orderDate',
            label: 'Fecha'
        },
        {
            selector: 'invoiceType',
            label: 'Tipo de Factura'
        },
        
        {
            selector: 'uuid',
            label: 'UUID'
        },
        {
            selector: 'invoiceNumber',
            label: 'Número de factura'
        },
        {
            selector: 'invoiceAmount',
            label: 'Importe de factura'
        },
        {
            selector: 'invoiceDate',
            label: 'Fecha factura'
        },
        {
            selector: 'invoiceStatus',
            label: 'Estatus'
        },
        //{
        //    selector: 'invoicePaymentDate',
        //    label: 'Fecha estimada de pago'
        //}
    ]
    const excelConfigurationPaidRejected = [
        {
            selector: 'folioQuote',
            label: 'Folio cotización'
        },
        {
            selector: 'poNumber',
            label: 'Número OC'
        },
        {
            selector: 'orderDate',
            label: 'Fecha'
        },
        {
            selector: 'invoiceType',
            label: 'Tipo de Factura'
        },

        {
            selector: 'uuid',
            label: 'UUID'
        },
        {
            selector: 'invoiceNumber',
            label: 'Número de factura'
        },
        {
            selector: 'invoiceAmount',
            label: 'Importe de factura'
        },
        {
            selector: 'invoiceDate',
            label: 'Fecha factura'
        },
        {
            selector: 'invoiceStatus',
            label: 'Estatus'
        },
        {
            selector: 'invoicePayRejectDate',
            label: 'Fecha de Pago / Rechazo'
        }
    ]
    const handleClose = () => {
        setOpen(false);
    }
    const handleToggle = () => {
        setOpen(!open);
    }

    useEffect(() => {
        const newRoute = {
            path: '/purchase/listByStatus',
            linkLegend: getFilteredTableTitle("Purchase", params.status),
            urlParams: [{ key: 'status', value: params.status }, { key: 'supplierId', value: params.supplierId }]
        }
        handleToggle()
        props.navigationActions.add_route(newRoute)
        props.purchaseActions.fecth_oc_by_status(props.userLanguage, props.userToken, params.supplierId, params.status, startDate, endDate, filterText, onError, onSuccess)
    }, [filterText, searchButton]) // eslint-disable-line react-hooks/exhaustive-deps

    const onError = (err) => {
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    console.log(err.response.data)
                    break
                default:
                    break
            }
        }
    }

    const onSuccess = () => {
        handleClose()
    }

    const subHeaderComponentMemo = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText('');
                props.purchaseActions.fecth_oc_by_status(props.userLanguage, props.userToken, params.supplierId, params.status, "", "", "", onError, onSuccess)
            }
        }

        const handleStartDateChange = (e) => {
            if (e != null)
                setStartDate(e.format('YYYY-MM-DD'))
            else
                setStartDate(null)
        }

        const handleEndDateChange = (e) => {
            if (e != null)
                setEndDate(e.format('YYYY-MM-DD'))
            else
                setEndDate(null)
        }

        const handleSearch = () => {
            if (filterText) {
                props.purchaseActions.fecth_oc_by_status(props.userLanguage, props.userToken, params.supplierId, params.status, "", "", filterText, onError, onSuccess)
            }
        }

        return <TableFilterComponent
            onFilter={e => setFilterText(e.target.value)}
            onSearch = {handleSearch}
            onClear={handleClear} filterText={filterText}
            onStartDateChange={handleStartDateChange}
            onEndDateChange={handleEndDateChange}
            onClickSearch={() => setSearchButton(searchButton + 1)}
            onExport={() => {
                downloadCSV(props.listByStatus, getExcelConfiguration(params.status), params.status)
                console.log(props.listByStatus, params.status)
            }}
            styles={classes.searchAlign}
            props = {props}
            params = {params}
            
        />;
    }, [filterText, resetPaginationToggle, searchButton, props]) // eslint-disable-line react-hooks/exhaustive-deps

    //start - To columns and sortFuntion in dates ordering table
    const optionsForStatusAssigned = [
        'Detalle'
    ]

    const caseInsensitiveSort = (rowA, rowB) => {
        const a = new Date(rowA.orderDate);
        const b = new Date(rowB.orderDate);

        if (a > b) {
            return 1;
        }

        if (b > a) {
            return -1;
        }

        return 0;
    };

    const ColumnsForStatusAssigned = (
        [
            {
                cell: row => <TableContextMenuComponent row={row} menuOptions={optionsForStatusAssigned} />,
                allowOverflow: true,
                button: true,
                width: '50px', // custom width for icon button
                name: 'Detalle'
            },
            {
                name: 'Folio Cotización',
                selector: 'folioQuote',
                width: '90px',
                sortable: true,
                cell: row => row.folioQuote
            },
            // {
            //     name: 'Folio Orden',
            //     selector: 'orderNumber',
            //     width: '90px',
            //     sortable: true,
            //     cell: row => row.orderNumber
            // },
            {
                name: 'Fecha',
                selector: 'orderDate',
                sortable: true,
                sortFunction: caseInsensitiveSort,
                cell: row => row.orderDate
            },
            {
                name: 'Vin',
                selector: 'vin',
                width: '165px',
                sortable: true,
                cell: row => row.vin
            },
            {
                name: 'Número OC',
                selector: 'poNumber',
                width: '150px',
                sortable: true,
                cell: row => row.poNumber
            },
            {
                name: 'Marca',
                selector: 'brand',
                sortable: true,
                cel: row => row.brand
            },
            {
                name: 'Modelo',
                selector: 'model',
                width: '130px',
                sortable: true,
                cell: row => row.model
            },
            {
                name: 'Versión',
                selector: 'version',
                width: '160px',
                sortable: true,
                cell: row => row.version
            },
            {
                name: 'Año',
                selector: 'year',
                sortable: true,
                width: '70px',
                cell: row => row.year
            },
            {
                name: 'Días Transcurridos',
                selector: 'daysPassed',
                sortable: true,
                cell: row => row.daysPassed
            },
            {
                name: 'Fecha de pago',
                selector: 'paymentDate',
                sortable: true,
                cell: row => row.paymentDate
            },
            {
                name: 'Notificaciones',
                selector: 'notifications',
                sortable: true,
                width: '114px',
                cell: row => row.notifications === true ? "Si" : "No"
            },
        ]
    )

    const ColumnsForStatusPaymentPending = (
        [
            {
                cell: row => <TableContextMenuComponent row={row} menuOptions={optionsForStatusAssigned} isInvoice={true} />,
                allowOverflow: true,
                button: true,
                width: '50px', // custom width for icon button
                name: 'Detalle'
            },
            {
                name: 'Folio Cotización',
                selector: 'folioQuote',
                width: '90px',
                sortable: true,
                cell: row => row.folioQuote
            },
            {
                name: 'Número OC',
                selector: 'poNumber',
                width: '150px',
                sortable: true,
                cell: row => row.poNumber
            },
            {
                name: 'Fecha',
                selector: 'orderDate',
                sortable: true,
                sortFunction: caseInsensitiveSort,
                cell: row => row.orderDate
            },
            {
                name: 'Vin',
                selector: 'vin',
                width: '165px',
                sortable: true,
                cell: row => row.vin
            },
            {
                name: 'Tipo de factura',
                selector: 'invoiceType',
                width: '130px',
                sortable: true,
                cell: row => getInvoiceType(row.invoiceType)
            },
            {
                name: 'UUID',
                selector: 'uuid',
                sortable: true,
                width: '165px',
                cell: row => row.uuid
            },
            {
                name: 'Número de factura',
                selector: 'invoiceNumber',
                sortable: true,
                cell: row => row.invoiceNumber
            },
            {
                name: 'Importe de factura',
                selector: 'invoiceAmount',
                width: '130px',
                sortable: true,
                cell: row => row.invoiceAmount
            },
            {
                name: 'Fecha factura',
                selector: 'invoiceDate',
                sortable: true,
                cell: row => row.invoiceDate
            },
            {
                name: 'Estatus',
                selector: 'invoiceStatus',
                width: '150px',
                sortable: true,
                cell: row => getInvoiceStatus(row.invoiceStatus)
            },
            //{
            //    name: 'Fecha estimada de pago',
            //    selector: 'invoicePaymentDate',
            //    width: '130px',
            //    sortable: true,
            //    cell: row => row.invoicePaymentDate
            //},
        ]
    )

    const ColumnsForStatusPaidRejected = (
        [
            {
                cell: row => <TableContextMenuComponent row={row} menuOptions={optionsForStatusAssigned} isInvoice={true} />,
                allowOverflow: true,
                button: true,
                width: '50px', // custom width for icon button
                name: 'Detalle'
            },
            {
                name: 'Folio Cotización',
                selector: 'folioQuote',
                width: '90px',
                sortable: true,
                cell: row => row.folioQuote
            },
            {
                name: 'Número OC',
                selector: 'poNumber',
                width: '150px',
                sortable: true,
                cell: row => row.poNumber
            },
            {
                name: 'Fecha',
                selector: 'orderDate',
                sortable: true,
                sortFunction: caseInsensitiveSort,
                cell: row => row.orderDate
            },
            {
                name: 'Vin',
                selector: 'vin',
                width: '165px',
                sortable: true,
                cell: row => row.vin
            },
            {
                name: 'Tipo de factura',
                selector: 'invoiceType',
                width: '130px',
                sortable: true,
                cell: row => getInvoiceType(row.invoiceType)
            },
            {
                name: 'UUID',
                selector: 'uuid',
                sortable: true,
                width: '165px',
                cell: row => row.uuid
            },
            {
                name: 'Número de factura',
                selector: 'invoiceNumber',
                sortable: true,
                cell: row => row.invoiceNumber
            },
            {
                name: 'Importe de factura',
                selector: 'invoiceAmount',
                width: '130px',
                sortable: true,
                cell: row => row.invoiceAmount
            },
            {
                name: 'Fecha factura',
                selector: 'invoiceDate',
                sortable: true,
                cell: row => row.invoiceDate
            },
            {
                name: 'Estatus',
                selector: 'invoiceStatus',
                width: '110px',
                sortable: true,
                cell: row => getInvoiceStatus(row.invoiceStatus)
            },
            {
                name: 'Fecha de Pago / Rechazo',
                selector: 'invoicePayRejectDate',
                width: '130px',
                sortable: true,
                cell: row => row.invoicePayRejectDate
            },
        ]
    )
    //end - To columns and sortFuntion in dates ordering table
    const getInvoiceType = (code) =>   {
        switch (code) {
            case 'VE':
                return 'Vehículo'
            case 'NC':
                return 'Nota de crédito'
            case 'AC':
            case 'ACNOT':
                return 'Accesorio'
            default:
                return 'Trámite'

        }
    }

    const getInvoiceStatus = (invoiceStatus) => {
        switch (invoiceStatus) {
            case '73':
                return 'En proceso de pago'
            case '74':
                return 'En proceso de pago'
            case '75':
                return 'En proceso de pago'
            case '80':
                return 'PAGADO'
            case '81':
                return 'CANCELADO'
            default:
                return ''

        }
    }
    return (
        <div>
            <TopBarNav />
            <br />
            <BreadcrumbsHistory />
            <br />
            <Container maxWidth="lg" className={classes.root}>
                <Grid>
                    <Backdrop className={classes.backdrop} open={open}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    {
                        params.status && params.status === '17' && (
                            <p className={classes.tableTitleAP}>{getFilteredTableTitle("Purchase", params.status)}</p>
                        )
                    }
                    <DataTable
                        title={params.status === '17' ? <p style={{ fontWeight: '600' }}>{Constants.LegendsForAP.paymentStatus}</p> : getFilteredTableTitle("Purchase", params.status)}
                        columns={getTableColumns(params.status)}
                        data={props.listByStatus}
                        defaultSortField="folioOrder"
                        customStyles={params.status === '17' ? customStylePrincipalAP : customStylePrincipal}
                        highlightOnHover
                        dense
                        responsive
                        striped
                        pointerOnHover
                        pagination
                        paginationComponentOptions={paginationOptions}
                        subHeader
                        subHeaderComponent={subHeaderComponentMemo}
                        noDataComponent={<p className={classes.marginNoData}>{t('commonMessages.noData')}</p>}
                    />
                </Grid>
                <br />
            </Container>
        </div>
    )
}

const mapStateToProps = state => ({
    userProfile: state.UserProfileReducer.list,
    listByStatus: state.PurchaseReducer.OrderList,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language,
    navList: state.NavigationReducer.routeList
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        purchaseActions: bindActionCreators(purchaseActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(PurchaseStyles)(PurchaseListByStatus))